/**
 * Ad + soyad → tek satırlık görünen ad (090).
 *
 * Sunucu bu birleştirmeyi **yapmaz** (ad ve soyad ayrı kolonlardır ve tabloda ayrı ayrı okunabilir
 * olmaları gerekir); istemci tarafında tek yerde yapılır ki tablo hücresi, seçici kutusu ve seçici
 * paneli aynı biçimi göstersin.
 *
 * İkisi de boşsa boş metin döner — çağıran o durumda kimliği/yer tutucuyu kendisi gösterir
 * (`USERS` satırı silinmiş kişi).
 */
export function proxyUserLabel(
  name: string | null | undefined,
  surname: string | null | undefined,
): string {
  return [name, surname].filter((p) => !!p && p.trim() !== '').join(' ')
}
